import React, {Component} from 'react'
import i18n from "i18next";

export default class Relations extends Component {

    render() {

        let {title, relations} = this.props;
        if (!relations.length) {
            return "";
        }

        return (
            <li>
                <div className="search-card-relations mt-5">
                    <strong>{title} </strong>
                    <ul>
                        {
                            relations.map((relation, index) => {
                                let {name, propId, desc} = relation;

                                return <li key={index}>
                                    <span
                                        className="color-ss-yellow">{i18n.t('relation_' + propId) + " "}</span>-<span>{" " + name}</span><span>{" (" + desc + ")"}</span>
                                </li>;
                            })
                        }
                    </ul>
                </div>
            </li>
        )
    }
}